export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">

        {/* Centered Logo */}
        <div className="flex justify-center mb-12">
          <img
            src="https://public.readdy.ai/ai/img_res/edited_3104d769bd1159b333c68f9b62bd5c48_95d4f063.jpg"
            alt="Quality 1st Construction LLC"
            className="w-40 h-auto object-contain rounded-lg"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">

          {/* Column 1 - Our Services */}
          <div>
            <h4 className="text-lg font-bold mb-4 pb-2 border-b-2 border-blue-600">
              Our Services
            </h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Kitchen Remodeling
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Bathroom Renovation
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Finished Basements
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Insurance Restoration
                </button>
              </li>
            </ul>
          </div>

          {/* Column 2 - New blank column */}
          <div>
            <h4 className="text-lg font-bold mb-4 pb-2 border-b-2 border-blue-600">
              &nbsp;
            </h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Professional Crown Molding Installation
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Kitchen backsplash tile
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Interior door and trim install
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Expert Wall &amp; Floor Tile Setting
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3 - Empty blank column */}
          <div>
            <h4 className="text-lg font-bold mb-4 pb-2 border-b-2 border-blue-600">
              &nbsp;
            </h4>
            <ul className="space-y-3">
              <li className="text-gray-400 whitespace-nowrap">LED low voltage lighting</li>
              <li className="text-gray-400 whitespace-nowrap">Can Lighting/ Ceiling Wafer Lights</li>
              <li className="text-gray-400 whitespace-nowrap">Ceiling Fans/ Coach lights</li>
              <li className="text-gray-400 whitespace-nowrap">We accept small repair work</li>
            </ul>
          </div>

          {/* Column 4 - Get In Touch */}
          <div>
            <h4 className="text-lg font-bold mb-4 pb-2 border-b-2 border-blue-600">
              Get In Touch
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2">
                <i className="ri-user-line text-blue-400"></i>
                <span className="text-gray-400 whitespace-nowrap">Ken Svihla</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-phone-line text-blue-400"></i>
                <a
                  href="tel:+17087077211"
                  className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  (708) 707-7211
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-mail-line text-blue-400"></i>
                <a
                  href="mailto:Ken@QualityFirst-Construction.com"
                  className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Ken@QualityFirst-Construction.com
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-time-line text-blue-400 mt-1"></i>
                <span className="text-gray-400">
                  Mon-Fri: 8AM - 6PM
                  <br />
                  Sat: 9AM - 4PM
                </span>
              </li>
            </ul>
          </div>

        </div>

        <div className="border-t border-gray-800 pt-8">
        </div>
      </div>
    </footer>
  );
}
